"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LineString = _interopRequireDefault(require("../../geom/LineString"));

var _Geometry = _interopRequireDefault(require("../../geom/Geometry"));

var _PolygonizeGraph = _interopRequireDefault(require("./PolygonizeGraph"));

var _hasInterface = _interopRequireDefault(require("../../../../../hasInterface"));

var _GeometryFactory = _interopRequireDefault(require("../../geom/GeometryFactory"));

var _Collection = _interopRequireDefault(require("../../../../../java/util/Collection"));

var _Collections = _interopRequireDefault(require("../../../../../java/util/Collections"));

var _EdgeRing = _interopRequireDefault(require("./EdgeRing"));

var _GeometryComponentFilter = _interopRequireDefault(require("../../geom/GeometryComponentFilter"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Polygonizer =
/*#__PURE__*/
function () {
  function Polygonizer() {
    _classCallCheck(this, Polygonizer);

    Polygonizer.constructor_.apply(this, arguments);
  }

  _createClass(Polygonizer, [{
    key: "getGeometry",
    value: function getGeometry() {
      if (this._geomFactory === null) this._geomFactory = new _GeometryFactory.default();
      this.polygonize();

      if (this._extractOnlyPolygonal) {
        return this._geomFactory.buildGeometry(this._polyList);
      }

      return this._geomFactory.createGeometryCollection(_GeometryFactory.default.toGeometryArray(this._polyList));
    }
  }, {
    key: "getInvalidRingLines",
    value: function getInvalidRingLines() {
      this.polygonize();
      return this._invalidRingLines;
    }
  }, {
    key: "findValidRings",
    value: function findValidRings(edgeRingList, validEdgeRingList, invalidRingList) {
      for (var i = edgeRingList.iterator(); i.hasNext();) {
        var er = i.next();
        if (er.isValid()) validEdgeRingList.add(er);else invalidRingList.add(er.getLineString());
      }
    }
  }, {
    key: "polygonize",
    value: function polygonize() {
      if (this._polyList !== null) return null;
      this._polyList = new _ArrayList.default();
      if (this._graph === null) return null;
      this._dangles = this._graph.deleteDangles();
      this._cutEdges = this._graph.deleteCutEdges();

      var edgeRingList = this._graph.getEdgeRings();

      var validEdgeRingList = new _ArrayList.default();
      this._invalidRingLines = new _ArrayList.default();

      if (this._isCheckingRingsValid) {
        this.findValidRings(edgeRingList, validEdgeRingList, this._invalidRingLines);
      } else {
        validEdgeRingList = edgeRingList;
      }

      this.findShellsAndHoles(validEdgeRingList);
      Polygonizer.assignHolesToShells(this._holeList, this._shellList);

      _Collections.default.sort(this._shellList, new _EdgeRing.default.EnvelopeComparator());

      var includeAll = true;

      if (this._extractOnlyPolygonal) {
        Polygonizer.findDisjointShells(this._shellList);
        includeAll = false;
      }

      this._polyList = Polygonizer.extractPolygons(this._shellList, includeAll);
    }
  }, {
    key: "getDangles",
    value: function getDangles() {
      this.polygonize();
      return this._dangles;
    }
  }, {
    key: "getCutEdges",
    value: function getCutEdges() {
      this.polygonize();
      return this._cutEdges;
    }
  }, {
    key: "getPolygons",
    value: function getPolygons() {
      this.polygonize();
      return this._polyList;
    }
  }, {
    key: "add",
    value: function add() {
      if ((0, _hasInterface.default)(arguments[0], _Collection.default)) {
        var geomList = arguments[0];

        for (var i = geomList.iterator(); i.hasNext();) {
          var geometry = i.next();
          this.add(geometry);
        }
      } else if (arguments[0] instanceof _LineString.default) {
        var line = arguments[0];
        this._geomFactory = line.getFactory();
        if (this._graph === null) this._graph = new _PolygonizeGraph.default(this._geomFactory);

        this._graph.addEdge(line);
      } else if (arguments[0] instanceof _Geometry.default) {
        var g = arguments[0];
        g.apply(this._lineStringAdder);
      }
    }
  }, {
    key: "setCheckRingsValid",
    value: function setCheckRingsValid(isCheckingRingsValid) {
      this._isCheckingRingsValid = isCheckingRingsValid;
    }
  }, {
    key: "findShellsAndHoles",
    value: function findShellsAndHoles(edgeRingList) {
      this._holeList = new _ArrayList.default();
      this._shellList = new _ArrayList.default();

      for (var i = edgeRingList.iterator(); i.hasNext();) {
        var er = i.next();
        er.computeHole();
        if (er.isHole()) this._holeList.add(er);else this._shellList.add(er);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Polygonizer;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "findOuterShells",
    value: function findOuterShells(shellList) {
      for (var i = shellList.iterator(); i.hasNext();) {
        var er = i.next();
        var outerHoleER = er.getOuterHole();

        if (outerHoleER !== null && !outerHoleER.isProcessed()) {
          er.setIncluded(true);
          outerHoleER.setProcessed(true);
        }
      }
    }
  }, {
    key: "extractPolygons",
    value: function extractPolygons(shellList, includeAll) {
      var polyList = new _ArrayList.default();

      for (var i = shellList.iterator(); i.hasNext();) {
        var er = i.next();

        if (includeAll || er.isIncluded()) {
          polyList.add(er.getPolygon());
        }
      }

      return polyList;
    }
  }, {
    key: "assignHolesToShells",
    value: function assignHolesToShells(holeList, shellList) {
      for (var i = holeList.iterator(); i.hasNext();) {
        var holeER = i.next();
        Polygonizer.assignHoleToShell(holeER, shellList);
      }
    }
  }, {
    key: "assignHoleToShell",
    value: function assignHoleToShell(holeER, shellList) {
      var shell = _EdgeRing.default.findEdgeRingContaining(holeER, shellList);

      if (shell !== null) {
        shell.addHole(holeER);
      }
    }
  }, {
    key: "findDisjointShells",
    value: function findDisjointShells(shellList) {
      Polygonizer.findOuterShells(shellList);
      var isMoreToScan = null;

      do {
        isMoreToScan = false;

        for (var i = shellList.iterator(); i.hasNext();) {
          var er = i.next();
          if (er.isIncludedSet()) continue;
          er.updateIncluded();

          if (!er.isIncludedSet()) {
            isMoreToScan = true;
          }
        }
      } while (isMoreToScan);
    }
  }]);

  return Polygonizer;
}();

exports.default = Polygonizer;

var LineStringAdder =
/*#__PURE__*/
function () {
  function LineStringAdder() {
    _classCallCheck(this, LineStringAdder);

    LineStringAdder.constructor_.apply(this, arguments);
  }

  _createClass(LineStringAdder, [{
    key: "filter",
    value: function filter(g) {
      if (g instanceof _LineString.default) this.p.add(g);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return LineStringAdder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_GeometryComponentFilter.default];
    }
  }]);

  return LineStringAdder;
}();

LineStringAdder.constructor_ = function () {
  this.p = null;
  var p = arguments[0];
  this.p = p;
};

Polygonizer.LineStringAdder = LineStringAdder;

Polygonizer.constructor_ = function () {
  this._lineStringAdder = new LineStringAdder(this);
  this._graph = null;
  this._dangles = new _ArrayList.default();
  this._cutEdges = new _ArrayList.default();
  this._invalidRingLines = new _ArrayList.default();
  this._holeList = null;
  this._shellList = null;
  this._polyList = null;
  this._isCheckingRingsValid = true;
  this._extractOnlyPolygonal = null;
  this._geomFactory = null;

  if (arguments.length === 0) {
    Polygonizer.constructor_.call(this, false);
  } else if (arguments.length === 1) {
    var extractOnlyPolygonal = arguments[0];
    this._extractOnlyPolygonal = extractOnlyPolygonal;
  }
};